// extracted by mini-css-extract-plugin
export var servicesList = "services-list-module--services-list--Sy6Qh";
export var servicesListViewAll = "services-list-module--services-list__view-all--rQduy";